import React from 'react';
import Moment from 'moment';
import { I18nextProvider as BaseProvider } from 'react-i18next';
import type { WithChildrenProps } from '../types/components/common';

import i18n from '../i18n/i18n';
import { clearDateFormatCache } from '../utils/hooks/useDateFormat';

function I18nextProvider({ children }: WithChildrenProps) {
  React.useEffect(() => {
    Moment.defineLocale('en-au', {
      parentLocale: 'en-gb',
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
      },
    });

    Moment.defineLocale('en-gb', {
      parentLocale: 'en',
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
      },
    });

    const applyMomentLocale = (lng: string) => {
      const lower = (lng || '').toLowerCase();
      const momentLocale = lower.startsWith('en-au')
        ? 'en-au'
        : lower.startsWith('en-gb')
        ? 'en-gb'
        : 'en';

      Moment.locale(momentLocale);
      clearDateFormatCache();
    };

    applyMomentLocale(i18n.language);

    const handler = (lng: string) => applyMomentLocale(lng);
    i18n.on('languageChanged', handler);
    return () => {
      i18n.off('languageChanged', handler);
    };
  }, []);

  return (
    <React.Suspense fallback={<div />}>
      <BaseProvider i18n={i18n}>{children}</BaseProvider>
    </React.Suspense>
  );
}

export default I18nextProvider;
